@if (run) {
  {{text}} {{ticks}}
}
